<template>
  <div class="campaign-home">
    <router-view></router-view>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
export default {
  name: "CampaignHome",
  computed: {
    ...mapGetters("agency", ["currentAgencyId"]),
    ...mapGetters("user", ["currentToken"]),
  },
};
</script>

<style lang="scss">
.campaign-home {
  width: 100%;
  height: 100%;
}
</style>
